import { useQuery } from '@tanstack/react-query';

import { MIN_SEARCH_LENGTH } from '@/components/features/UsersList/constants';
import { useAuth } from '@/contexts/AuthContext';
import { createApiClient } from '@/shared/api/apiClient';

export interface UseBudgetGroupsAutocompleteOptions {
  organizationId: number;
  filter: string;
  enabled?: boolean;
}

export function useBudgetGroupsAutocomplete({ organizationId, filter, enabled = true }: UseBudgetGroupsAutocompleteOptions) {
  const { getAccessToken } = useAuth();

  return useQuery({
    queryKey: ['budget-groups-autocomplete', organizationId, filter],
    queryFn: async ({ signal }) => {
      const client = createApiClient(getAccessToken, {
        cache: 'no-store',
        signal,
      });

      const { data, error } = await client.GET('/api/organizations/{organizationId}/budget-groups/autocomplete', {
        params: {
          path: { organizationId },
          query: { Filter: filter },
        },
      });

      if (error) {
        throw new Error(error.title || 'Failed to fetch budget groups');
      }

      return data ?? [];
    },
    enabled: enabled && filter.length >= MIN_SEARCH_LENGTH,
    staleTime: 30000,
  });
}
